import React, { Component } from 'react';
import FilledInput from '@material-ui/core/FilledInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { onFormInputKeyDown } from '../helpers/HelperFunctions';
import { v4 } from 'uuid';

export class CashField extends Component {
    constructor(props) {
        super(props);
        const { value } = this.props;
        this.state = {
            value: value ? this.updateValue(value): '',
            id: v4()
        };
        this.handleChange = this.handleChange.bind(this);
        this.formatValue = this.formatValue.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }
    render() {
        const { name, disabled, label } = this.props;
        const { value, id } = this.state;
        return (
            <FormControl sx={{ m: 1, width: '25ch' }} variant="filled">
                <InputLabel htmlFor={id} >{label}</InputLabel>
                <FilledInput
                    id={id}
                    name={name}
                    endAdornment={<InputAdornment position="end">грн</InputAdornment>}
                    inputProps={{
                        'aria-label': 'weight',
                    }}
                    value={value}
                    onBlur={this.onBlur}
                    onChange={this.handleChange}
                    onKeyDown={this.onKeyDown}
                    disabled={disabled ? true : false}
                />
            </FormControl>
        );
    }
    onBlur(e) {
        let { value } = this.state;
        let oldValue = value ? value.slice() : '';
        value = this.updateValue(value);
        if (value !== oldValue) {
            e.target.value = value;
            this.setState({ value: value });
            if (this.props.onChange)
                this.props.onChange(e);
        }
    }
    onKeyDown(e) {
        if ((e.key === '.' || e.key === ',') && this.state.value.includes(',')) {
            e.preventDefault();
            e.stopPropagation();
        }
        else {
            onFormInputKeyDown(e);
        }
    }
    updateValue(value) {
        if (!value)
            value = '0,00';
        if (value.indexOf(',') === -1) {
            value += ',00';
        }
        else {
            let part1 = value.split(',')[0];
            if (!part1)
                part1 = '0';
            let part2 = value.split(',')[1];
            while (part2.length < 2)
                part2 += '0';
            value = part1 + ',' + part2;
        }
        return value;
    }
    handleChange(e) {
        const { value } = e.target;
        const { id } = this.state;
        let formatedValue = value.replaceAll(' ', '').replaceAll('.', ',');

        if ((/^[0-9]{0,}[,]?[0-9]{0,}$/).test(formatedValue) || !formatedValue) {
            let caretPos = { pos: e.target.selectionStart };
            formatedValue = this.formatValue(formatedValue, caretPos);
            e.target.value = formatedValue;
            this.setState({ value: formatedValue }, () => {
                let element = document.getElementById(id);
                element.setSelectionRange(caretPos.pos, caretPos.pos);
            });
            if (this.props.onChange)
                this.props.onChange(e);
        }
    }
    formatValue(value, caretPos) {
        let caretDif = 0;
        let stateValue = this.state.value.replaceAll(' ', '');
        const element = document.getElementById(this.state.id);
        if (value.indexOf(',') === -1) {
            let stateIndex = stateValue.indexOf(',');
            if (stateIndex !== -1 && value.slice(0, stateIndex) + ',' + value.slice(stateIndex) === stateValue) {
                if (value + ',' !== stateValue) {
                    value = this.state.value;                    
                }
                else
                    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }
            else {
                while (value.length > 1 && value[0] === '0') {
                    value = value.substring(1);
                }
                value = value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }
        }
        else {
            let part1 = value.split(',')[0];
            if (part1) {
                while (part1.length > 1 && part1[0] === '0') {
                    part1 = part1.substring(1);
                }
            }
            else
                part1 = '0';

            let part2 = value.split(',')[1];
            if (part2.length > 2) {
                part2 = part2.slice(0, 2);
                caretDif++;
            }

            value = part1.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ',' + part2;
        }
        if (value !== this.state.value)
            caretDif += value.length - element.value.length;
        caretPos.pos += caretDif;
        caretPos.pos = Math.min(caretPos.pos, value.length);
        caretPos.pos = Math.max(caretPos.pos, 0);
        return value;
    }
}